import React from 'react'
import { Trans } from '@lingui/macro'

import { SurveyResponses } from '../../../../../../back-end/src/models/gql/survey-types/surveyTypes'
import { countWidthRate } from '../../helpers'
import { motion } from 'framer-motion'
import './SurveyResultBar.less'
import { Box, Flex } from 'front-end/src/components'

const SurveyResultBar = ({ responses }: { responses: SurveyResponses }) => {
  const { totalCount, startedCount, completedCount } = responses

  const animationForOpen = {
    initial: {
      width: '0%'
    },
    animate: {
      width: `${countWidthRate(startedCount, totalCount)}`
    }
  }

  const animationForCompleted = {
    initial: {
      width: '0%'
    },
    animate: {
      width: `${countWidthRate(completedCount, totalCount)}`
    }
  }

  return (
    <Flex
      className="SurveyResultBar"
      flexFlow="row nowrap"
      alignItems="center"
      pl="8px"
    >
      <Box className="SurveyResultBar__value">
        <span className="SurveyResultBar__value__label">
          <Trans>Responses</Trans>
        </span>
        <span className="SurveyResultBar__value__number green">
          {completedCount}
        </span>
      </Box>
      <Box
        className="SurveyResultBar__stripe"
        w={[null, '100px', '100px', '200px']}
      >
        <motion.span
          className="SurveyResultBar__stripe__opened"
          {...animationForOpen}
        />
        <motion.span
          className="SurveyResultBar__stripe__responses"
          {...animationForCompleted}
        />
      </Box>
      <Box className="SurveyResultBar__value">
        <span className="SurveyResultBar__value__label">
          <Trans>Sent</Trans>
        </span>
        <span className="SurveyResultBar__value__number">{totalCount}</span>
      </Box>

      <Box className="SurveyResultBar__value rate">
        <span className="SurveyResultBar__value__label">
          <Trans>Response rate</Trans>
        </span>
        <span className="SurveyResultBar__value__number">
          {completedCount ? countWidthRate(completedCount, totalCount) : '-'}
        </span>
      </Box>
    </Flex>
  )
}

export default SurveyResultBar
